// extracted by mini-css-extract-plugin
export default {"root":"IconPdf_root__9vpfh"};